/* global axios */
import ApiClient from './ApiClient';

// SiteUp (Cartões de Apoio): recarga dos dados dos chips da sugestão. O POST não busca
// nada na hora — ele entrega o que o job já gravou ou devolve `processing`, e quem
// chamou volta a perguntar. Por isso o painel pergunta em intervalo, sem travar a tela.
class AssistCardsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  refresh(conversationId) {
    return axios.post(`${this.url}/${conversationId}/assist_cards`);
  }
}

export default new AssistCardsAPI();
